// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BGfm","content":"styles_content__fGQen"};